export default __webpack_public_path__ + "static/media/img7.e26d2bd9.jpg";